import moment from "moment";
import "moment/locale/id";
import { capitalize } from "../../../../../components/helpers";

export const convertEmployee = (data) => {
  let converted = {};

  if (!data) return {};

  converted = {
    key: data.id,
    id: data.id ?? "-",
    name: `${capitalize(data.first_name)} ${capitalize(data.last_name)}`,
    phone: data?.phone ?? "-",
    email: data.email,
    outlet: data.outlet?.name ?? "-",
    lastLogin: "",
    status: data.is_active ? "Aktif" : "Non Aktif" ?? "-",
    jabatan: data.jabatan.name,
    birthDate: moment(data.date_of_birth).format("DD MMMM YYYY"),
    gender:
      data.gender === "M"
        ? "Laki-laki"
        : data?.gender === "F"
        ? "Perempuan"
        : data?.gender,
    address: data?.address,
    photo:data?.profil_picture
  };
  return converted;
};
